export default "__VITE_ASSET__CEZxPZ8j__"